import { SecureStorageService } from '../../services/secure-storage.service';
import { inject } from '@angular/core';

interface User {
    id: number;
    name: string;
    email: string;
    permissions: string[];
    roles: Array<{
        id: number;
        name: string;
        display_name: string;
    }>;
}

export function getCurrentUser(): User | null {
    const secureStorage = inject(SecureStorageService);
    return secureStorage.getItem<User>('user');
}

export function getCurrentUserId(): string | null {
    const secureStorage = inject(SecureStorageService);
    return secureStorage.getItem<string>('id');
}
